import { render, staticRenderFns } from "./tabContent.vue?vue&type=template&id=0d85ea10&scoped=true"
import script from "./tabContent.vue?vue&type=script&lang=js"
export * from "./tabContent.vue?vue&type=script&lang=js"
import style0 from "./tabContent.vue?vue&type=style&index=0&id=0d85ea10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85ea10",
  null
  
)

export default component.exports